// tslint:disable: max-line-length
import { CustomItem, FindParamsDefault } from '@domains';
import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './custom-item.actions';

export interface CustomItemState {
  items: Array<CustomItem>;
  itemsTotalCount: number;
  item: CustomItem;
  createdItem: CustomItem;
  updatedItem: CustomItem;
  deletedItemId: number;
  findParams: { [key: string]: FindParamsDefault };
}

const initialState: CustomItemState = {
  items: new Array<CustomItem>(),
  itemsTotalCount: 0,
  item: undefined,
  createdItem: undefined,
  updatedItem: undefined,
  deletedItemId: 0,
  findParams: JSON.parse(localStorage.getItem('ItemFindParams') || '{}'),
};

const reducer = createReducer(
  initialState,

  on(fromActions.getCustomItems, (state, { findParams, keep }) => {
    const newValue = { ...state.findParams };
    newValue[window.location.pathname] = findParams;
    return { ...state, itemsTotalCount: keep ? state.itemsTotalCount : 0, items: keep ? state.items : [], findParams: newValue };
  }),
  on(fromActions.getCustomItemsSuccess, (state, { resultsCount, results }) => ({
    ...state,
    itemsTotalCount: resultsCount,
    items: results,
  })),
  on(fromActions.clearCustomItems, (state) => ({
    ...state,
    itemsTotalCount: 0,
    items: new Array<CustomItem>(),
  })),
  on(fromActions.clearCustomItemsFindParams, (state) => {
    const newValue = { ...state.findParams };
    newValue[window.location.pathname] = {};
    return { ...state, findParams: newValue };
  }),

  on(fromActions.getCustomItem, (state) => ({ ...state, item: null })),
  on(fromActions.getCustomItemSuccess, (state, action: any) => ({ ...state, item: new CustomItem(action.item) })),

  on(fromActions.createCustomItemSuccess, (state, action: any) => ({ ...state, createdItem: action.item })),

  on(fromActions.updateCustomItemSuccess, (state, action: any) => ({ ...state, updatedItem: action.item })),

  on(fromActions.deleteCustomItemSuccess, (state, action: any) => ({ ...state, deletedItemId: action.itemId })),
);
export function customItemReducer(state: CustomItemState | undefined, action: Action) {
  return reducer(state, action);
}
